import { z } from 'zod';

export const PolygonEntityTypes = [
    'Boundary',
    'Paddock',
    'Yard',
    'Erosion Area',
    'Vegetation',
    'Dam',
] as const;

export function isPolygonEntityType(x: string): x is (typeof PolygonEntityTypes)[number] {
    return PolygonEntityTypes.some((type) => type === x);
}

export const PolyLineEntityTypes = ['Waterway', 'Fence'] as const;

export function isPolyLineEntityType(x: string): x is (typeof PolyLineEntityTypes)[number] {
    return PolyLineEntityTypes.some((type) => type === x);
}

export const BillboardEntityTypes = [
    'Gate',
    'Bridge Crossing',
    'Cool Room',
    'Shed',
    'House',
    'Silo',
    'Tank',
    'Herd',
    'Trough',
    'Note',
    'Task',
    'ProtagAnimal',
    'Device',
] as const;

export const AddNewEntities = [
    'Paddock',
    'Fence',
    'Dam',
    'Gate',
    'Waterway',
    'Silo',
    'Tank',
    'Vegetation',
    'House',
    'Trough',
    'Shed',
    'Yard',
    'Cool Room',
    'Bridge Crossing',
    'Erosion Area',
    'Note',
    'Task',
    'Herd',
    'Boundary',
] as const satisfies EntityType[];

export function isBillboardEntityType(x: string): x is (typeof BillboardEntityTypes)[number] {
    return BillboardEntityTypes.some((type) => type === x);
}

export const allEntityTypes = [
    ...PolygonEntityTypes,
    ...PolyLineEntityTypes,
    ...BillboardEntityTypes,
];

export const EntityTypeEnum = z.enum([
    ...PolygonEntityTypes,
    ...PolyLineEntityTypes,
    ...BillboardEntityTypes,
]);

export type EntityType = z.infer<typeof EntityTypeEnum>;

// Entities that can change on the map when the timeline is scrubbed.
// By definition every other entity type is fixed on the map i.e. the latest changes persist over all time
export const TimelineDependentEntities: EntityType[] = ['Herd'];

export function isEntityType(input?: string): input is EntityType {
    if (input == null) return false;
    return EntityTypeEnum.options.map((entityType) => entityType.toString()).includes(input);
}

export function entityTypeFromString(input?: string): EntityType | undefined {
    return isEntityType(input) ? input : undefined;
}

// A simple method to get the related stat names for an entity type. This doesn't retrieve all the related stat names,
// and doesn't work in all cases such as a Shed, that only has a location_stat.
// e.g. for a Paddock this will return "paddock_stat"
export function statNameFromEntityType(entityType: EntityType) {
    return `${entityType.toLowerCase().replace(' ', '_')}_stats`;
}
